import { CheckCircle2, PhoneCall } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FIRM } from "@/constants/firmInfo";

/**
 * Post-submit confirmation panel for ContactForm. Extracted into its own
 * component since it's a fully separate render branch (keeps ContactForm's
 * main body focused on the actual form fields).
 */
export const ContactFormSuccessPanel = ({ testIdPrefix, heading, body, submitAnotherLabel, onReset }) => (
  <div
    className="rounded-2xl border border-slate-200 bg-[color:var(--paper-2)] p-8 text-center"
    data-testid={`${testIdPrefix}-success-panel`}
  >
    <div className="mx-auto mb-4 h-14 w-14 rounded-full bg-emerald-100 grid place-items-center">
      <CheckCircle2 className="h-7 w-7 text-emerald-600" />
    </div>
    <h3 className="font-heading text-xl text-[color:var(--navy-950)] mb-2">{heading}</h3>
    <p className="text-sm text-slate-600 leading-relaxed">{body}</p>
    <a
      href={`tel:${FIRM.phoneTel}`}
      className="inline-flex items-center gap-2 mt-5 text-sm font-semibold text-[color:var(--navy-950)] hover:text-[color:var(--gold-500)]"
    >
      <PhoneCall className="h-4 w-4" /> {FIRM.phoneDisplay}
    </a>
    <div className="mt-5">
      <Button variant="outline" onClick={onReset} data-testid={`${testIdPrefix}-submit-another-button`}>
        {submitAnotherLabel}
      </Button>
    </div>
  </div>
);
